<template>
  <div>
    <div style="width: 100vw; background-color: #f9f9f9; display: flex; flex-direction: row; justify-content: center; align-items: center;">
      <div 
        :style="'width: '+($store.getters.getScreenWidth < 1400 ? '98%' : '90%')+'; padding-bottom: '+($store.getters.getScreenWidth>=650 ? '' : '40px')+'; padd max-width: 1920px; margin-top: 80px; display: flex; flex-direction: column; justify-content: center; align-items: center;'">
        <div :style="'display: flex; flex-direction: column; padding-bottom: 50px; width: '+($store.getters.getScreenWidth < 988 ? '70%' : '50%')+'; text-align: left;'">
          
          <span :style="'font-size: '+getFont54+'; font-weight: 500;'">
              Simple and Transparent<br>Pricing. We have no surprise charges.
          </span>
        
      </div>
    </div>
    </div>
  </div>
</template>

<script>

export default {
    computed: {
      getFont54() {
        if(this.$store.getters.getScreenWidth<560 && this.$store.getters.getScreenWidth>429) {
          return '34px'
        } else if(this.$store.getters.getScreenWidth<=429 && this.$store.getters.getScreenWidth>373) {
          return '30px'
        } else if(this.$store.getters.getScreenWidth<=373) {
          return '24px'
        }
        return this.$store.getters.getFontSizes.f54
      }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Pricing/Row1.vue